var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6396 9.2044C17.6396 8.56623 17.5823 7.95261 17.476 7.36353H8.99976V10.8448H13.8433C13.6347 11.9698 13.0006 12.923 12.0474 13.5611V15.8193H14.956C16.6578 14.2525 17.6396 11.9453 17.6396 9.2044Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99963 17.9996C11.4296 17.9996 13.4668 17.1937 14.9559 15.8192L12.0473 13.561C11.2414 14.101 10.2105 14.4201 8.99963 14.4201C6.65557 14.4201 4.67151 12.837 3.9638 10.7097H0.957031V13.0415C2.43792 15.9828 5.4815 17.9996 8.99963 17.9996Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.96403 10.7097C3.78403 10.1697 3.68176 9.59293 3.68176 8.99976C3.68176 8.40659 3.78403 7.82978 3.96403 7.28979V4.95801H0.957257C0.347721 6.17299 0 7.54751 0 8.99976C0 10.452 0.347721 11.8265 0.957257 13.0415L3.96403 10.7097Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99962 3.57949C10.321 3.57949 11.5073 4.03357 12.44 4.92537L15.0213 2.34405C13.4627 0.891803 11.4255 0 8.99962 0C5.4815 0 2.43792 2.01678 0.957031 4.9581L3.9638 7.28988C4.67151 5.16264 6.65557 3.57949 8.99962 3.57949Z",
    fill: "#EA4335"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/google-logo.d244b555.svg";
export { ForwardRef as ReactComponent };